import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice'; 

const store = configureStore({
  reducer: {
    // The key 'user' will be the name of the state slice
    // 'userReducer' is the reducer exported from your userSlice file
    user: userReducer,
  },
});

export default store;